import {CHANGE_LANG, CHANGE_PROFILE, LOGIN, LOGOUT} from "./actionTypes"


export const login = (data) => {
  return {
    type: LOGIN,
    user: data.user,
    error: data.error
  };
};
  
export const logout = () => {
  return {
    type: LOGOUT
  };
};

export const changeProfile = (data) => {
  return  {
    type: CHANGE_PROFILE,
    user: data
  }
}


export const changeLang = (data) => {
  return {
    type: CHANGE_LANG,
    lang: data.lang,
    locale: data.locale,
    flag: data.flag
  }
}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const formatYearMonth = (startDate, endDate, position) => {

  const [firstYear, firstMonth] = startDate.split("-").map(Number);
  const [secondYear, secondMonth] = endDate.split("-").map(Number);

  const firstDate = new Date(firstYear, firstMonth - 1);
  const secondDate = new Date(secondYear, secondMonth - 1);

  const firstMonthName = firstDate.toLocaleString("en-US", { month: "short" });
  const secondMonthName = secondDate.toLocaleString("en-US", { month: "short" });

  let newFirstYear = firstYear;
  let newSecondYear = secondYear;

  if(position > 0){
    newFirstYear = firstYear - 1;
    newSecondYear = secondYear - 1;
  }

  return `${firstMonthName}. ${newFirstYear} - ${secondMonthName}. ${newSecondYear}`;
}


export const labelOnTopPlugin = {
  id: 'labelOnTop',
  afterDatasetsDraw: (chart) => {
    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);
    const labels = chart.data.labels;

    ctx.save();
    meta.data.forEach((bar, index) => {
        const label = labels[index];
        const y = bar.y;

        ctx.font = 'normal 13.5px TWKLausanne';
        ctx.fillStyle = '#000';
        ctx.textAlign = 'start';
        ctx.fillText(label, 15, y - 20 );
    });
    ctx.restore();
  }
};


export const tooltipChartJSoptions = {
  displayColors: false,
  bodyFont: {
    size: 18,
    weight: 'bold',
    family: "Atkinson-Hyperlegible-Regular"
  },
  titleFont: {
    size: 16,
    weight: 'normal',
    family: "TWKLausanne"
  },
  align: "center",
  padding: 12
}

export const localizeValue = (value, locale) => {
    return typeof value === "undefined" ? "0" : Number(value).toLocaleString(locale);
};

export const formatNumber = (number, lang) => {
  if (number < 1000) return number.toString();

  const scaled = number / 1000;
  const formatted = scaled % 1 === 0 ? scaled.toFixed(0) : scaled.toFixed(1);

  return `${localizeValue(formatted, lang)}k`;
}


export const horizontalChartTooltipCallBack = (lang) => {
  return {
    title: (item) => item.formattedValue,
    label: function (context) {
      const value = context.parsed.x;
      const dataset = context.dataset;
      const total = dataset.data.reduce((sum, val) => sum + val, 0);
      const percentage = ((value / total) * 100).toFixed(1);
      return `${localizeValue(value, lang)} (${localizeValue(percentage, lang)}%)`;
    }
  }
}


export const lineTooltipCallBack = (lang) => {
  return {
    title: (item) => item.formattedValue,
    label: function (context) {
      const value = context.parsed.y;
      const dataset = context.dataset;
      const total = dataset.data.reduce((sum, val) => sum + val, 0);
      const percentage = ((value / total) * 100).toFixed(1);
      return `${localizeValue(value, lang)} (${localizeValue(percentage, lang)}%)`;
    }
  }
}


export const targetChartTooltipCallBack = (lang) => {
  return {
    title: (item) => item.formattedValue,
    label: function (context) {
        const value = context.parsed.x;

        const targetDataset = context.chart.data.datasets;
        
        let fullText = [];

        if (context.dataset.type === "bar") {
            fullText.push(`Bar: ${localizeValue(value, lang)}`);
            fullText.push(`Target: ${localizeValue(targetDataset[0].data[context.parsed.y])}`);
        }else{
            fullText.push(`Bar: ${localizeValue(context.chart.data.datasets[1].data[context.parsed.y])}`);
            fullText.push(`Target: ${localizeValue(value, lang)}`);
        }

        return fullText;
    }
  }
}

export const horizontalBarChartJSOptions = (lang) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      universalInnerLabel: {
        color: 'white',
        font: 'bold 14px Atkinson-Hyperlegible-Regular',
        formatter: (value) => localizeValue(value, lang),
        xAdjust: -3
      },
      tooltip: {...tooltipChartJSoptions, callbacks: horizontalChartTooltipCallBack(lang)},
      legend: {
          display: false
      },
      title: {
          display: false
      },
      datalabels: {
          color: 'white',
          anchor: 'center',
          align: 'center',
          formatter: (value) => value,
          font: {
            size: 15,
            weight: 'bold'
          }
      }
    },
    layout: {
      padding: {
        top: 10
      }
    },
    scales: {
      x: {
        display: true,
        beginAtZero: true,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: false
        },
        ticks: {
          display: false
        }
      },
      y: {
        display: false,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: false
        },
        ticks: {
          display: false
        }
      }
    }
  }
};

export const targetHorizontalBarChartJSOptions = (lang) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      universalInnerLabel: {
        color: 'white',
        font: 'bold 14px Atkinson-Hyperlegible-Regular',
        formatter: (value) => localizeValue(value, lang),
        xAdjust: -2
      },
      tooltip: {...tooltipChartJSoptions, callbacks: targetChartTooltipCallBack(lang)},
      legend: {
          display: false
      },
      title: {
          display: false
      },
      datalabels: {
          color: 'white',
          anchor: 'center',
          align: 'center',
          formatter: (value) => value,
          font: {
            size: 15,
            weight: 'bold'
          }
      }
    },
    layout: {
      padding: {
        top: 10
      }
    },
    scales: {
      x: {
        display: true,
        beginAtZero: true,
        stacked: false,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: false
        },
        ticks: {
          display: false
        }
      },
      y: {
        display: false,
        beginAtZero: true
      }
    }
  }
};

export const lineChartJSOptions = (lang) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {...tooltipChartJSoptions, callbacks: lineTooltipCallBack(lang)},
      legend: { 
        position: 'bottom',
        labels: {
          padding: 20,
          usePointStyle: true,
          pointStyle: 'circle'
        }
      },
      title: {
        display: false,
      },
      universalInnerLabel: {
        color: ["#c75efb", "#F6680B"],
        font: 'bold 15px Atkinson-Hyperlegible-Regular',
        formatter: (value) => formatNumber(value, lang),
        outlineWidth: 4, 
        outlineColor: "white"
      },
      datalabels: {
        anchor: 'start',
        offset: 8,
        align: 'top',
        formatter: (value) => value,
        font: {
          size: 15
        },
        color: "#000"
      }
    },
    layout: {
      padding: {
        top: 25,
        left: 35,
        right: 35
      }
    },
    scales:  {
      x: {
        display: true,
        beginAtZero: true,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: true
        },
        ticks: {
          color: "#F54562",
          font: {
            size: 12.5,
            weight: "bold",
            family: "Atkinson-Hyperlegible-Regular"
          }
        }
      },
      y: {
        display: true,
        grid: {
          display: true,
          color: '#ebebebff',
          drawBorder: true
        },
        ticks: {
          display: false
        }
      }
    }
  }
};



const formatFilter = (f) => {
  switch (f.filterType) {
    case "categorical":
      return {
        name: f.fieldName,
        type: f.filterType,
        appliedValues: f.appliedValues?.map((v) => v.value) ?? [],
      };

    case "range":
      return {
        name: f.fieldName,
        type: f.filterType,
        minValue: f.minValue ?? null,
        maxValue: f.maxValue ?? null,
      };

    case "relativedate":
      return {
        name: f.fieldName,
        type: f.filterType,
        periodType: f.periodType ?? null,
        rangeN: f.rangeN ?? null,
      };

    default:
      return {
        name: f.fieldName,
        type: f.filterType,
        appliedValues: f.appliedValues?.map((v) => v.value) ?? [],
      };
  }
};

const hasFilterValue = (filter) => {
  if (!filter) return false;

  if (Array.isArray(filter.appliedValues)) {
    return filter.appliedValues.length > 0;
  }

  if (filter.type === "range") {
    return filter.minValue != null || filter.maxValue != null;
  }

  if (filter.type === "relativedate") {
    return filter.periodType != null || filter.rangeN != null;
  }

  return false;
};


const formatParameter = (p) => ({
  name: p.name,
  dataType: p.dataType ?? null,
  currentValue: p.currentValue?.formattedValue,
});


export const handleFilterChange = async (
  event,
  scope,
  setDashboardFilters,
  publicTableau = false
) => {
  try {
    let tableauViz = document.getElementById("tableauViz");

    if (publicTableau) {
      tableauViz = publicTableau;
    }

    if (!tableauViz?.workbook) return;

    const tableauEvent = event?.detail ?? event;

    if (typeof tableauEvent?.getFilterAsync !== "function") {
      console.error("FilterChanged event non valido:", event);
      return;
    }

    const changedFilter = await tableauEvent.getFilterAsync();
    const formattedFilter = formatFilter(changedFilter);

    setDashboardFilters((prev) => {
      const prevScopeData = prev?.[scope] ?? {
        filters: [],
        parameters: [],
      };

      const existingFilters = prevScopeData.filters ?? [];

      const filterKey = (item) => `${item.name}-${item.type}`;
      const changedKey = filterKey(formattedFilter);

      const hasValue = hasFilterValue(formattedFilter);

      let updatedFilters;

      if (hasValue) {
        const index = existingFilters.findIndex(
          (item) => filterKey(item) === changedKey
        );

        updatedFilters =
          index >= 0
            ? existingFilters.map((item, i) =>
                i === index ? formattedFilter : item
              )
            : [...existingFilters, formattedFilter];
      } else {
        updatedFilters = existingFilters.filter(
          (item) => filterKey(item) !== changedKey
        );
      }

      if (updatedFilters.length === 0) {
        const { [scope]: _, ...rest } = prev ?? {};
        return rest;
      }

      return {
        ...(prev ?? {}),
        [scope]: {
          filters: updatedFilters,
          parameters: prevScopeData.parameters,
        },
      };
    });
  } catch (error) {
    console.error("Error reading changed filter:", error);
  }
};


export const handleParameterChange = async (event, scope, setDashboardFilters, publicTableau = false) => {
  try {
    let tableauViz = document.getElementById("tableauViz");

    if (publicTableau) {
      tableauViz = publicTableau;
    }

    if (!tableauViz?.workbook) return;

    const tableauEvent = event?.detail ?? event;

    if (typeof tableauEvent?.getParameterAsync !== "function") {
      console.error("ParameterChanged event non valido:", event);
      return;
    }

    const changedParameter = await tableauEvent.getParameterAsync();
    const formattedParameter = formatParameter(changedParameter);

    setDashboardFilters((prev) => {
      const prevScopeData = prev?.[scope] ?? {
        filters: [],
        parameters: [],
      };

      const existingParameters = prevScopeData.parameters ?? [];
      const index = existingParameters.findIndex(
        (item) => item.name === formattedParameter.name
      );

      const updatedParameters =
        index >= 0
          ? existingParameters.map((item, i) =>
              i === index ? formattedParameter : item
            )
          : [...existingParameters, formattedParameter];

      return {
        ...(prev ?? {}),
        [scope]: {
          filters: prevScopeData.filters,
          parameters: updatedParameters,
        },
      };
    });
  } catch (error) {
    console.error("Error reading changed parameter:", error);
  }
};

export const applyExtraFilters = async (
  payload,
  scope,
  setDashboardFilters,
  publicTableau = false,
  setLoadingContent
) => {

  let tableauViz = document.getElementById("tableauViz");

  if (publicTableau) {
    tableauViz = publicTableau;
  }

  if (!tableauViz?.workbook) {
    setLoadingContent?.(false);
    return;
  }

  setDashboardFilters((prev) => ({
    ...(prev ?? {}),
    [scope]: payload,
  }));

  const workbook = tableauViz.workbook;
  const initialSheetName = workbook.activeSheet.name;

  const filters = Array.isArray(payload?.filters)
    ? payload.filters
    : [];

  const parameters = Array.isArray(payload?.parameters)
    ? payload.parameters
    : [];

  const failedOperations = [];

  let availableParameters = [];

  try {
    availableParameters =
      await workbook.getParametersAsync();
  } catch (error) {
    failedOperations.push({
      status: "rejected",
      reason: error,
      operation: "getParameters",
    });
  }

  const availableParameterNames = new Set(
    availableParameters.map(
      (parameter) => parameter.name
    )
  );

  const parameterOps = parameters
    .filter(
      (parameter) =>
        parameter?.name &&
        availableParameterNames.has(parameter.name)
    )
    .map((parameter) =>
      workbook.changeParameterValueAsync(
        parameter.name,
        parameter.currentValue
      )
    );

  const parameterResults =
    await Promise.allSettled(parameterOps);

  failedOperations.push(
    ...parameterResults.filter(
      (result) => result.status === "rejected"
    )
  );

  const publishedSheets =
    workbook.publishedSheetsInfo ?? [];

  try {
    for (const sheetInfo of publishedSheets) {
      let sheet;

      try {
        sheet = await workbook.activateSheetAsync(
          sheetInfo.name
        );
      } catch (error) {
        failedOperations.push({
          status: "rejected",
          reason: error,
          operation: "activateSheet",
          sheet: sheetInfo.name,
        });

        continue;
      }

      if (
        sheet.sheetType !== "dashboard" &&
        sheet.sheetType !== "worksheet"
      ) {
        continue;
      }

      let existingPageFilters = [];

      try {
        existingPageFilters =
          await sheet.getFiltersAsync();
      } catch (error) {
        failedOperations.push({
          status: "rejected",
          reason: error,
          operation: "getPageFilters",
          sheet: sheetInfo.name,
        });

        continue;
      }

      const pageFilterNames = new Set(
        existingPageFilters.map(
          (filter) => filter.fieldName
        )
      );

      const categoricalFilters = filters.filter(
        (filter) =>
          filter?.name &&
          filter.type === "categorical" &&
          pageFilterNames.has(filter.name)
      );

      const worksheetOnlyFilters = filters.filter(
        (filter) =>
          filter?.name &&
          (
            filter.type === "range" ||
            filter.type === "relativedate"
          ) &&
          pageFilterNames.has(filter.name)
      );

      const pageOperations = [];

      for (const filter of categoricalFilters) {
        if (sheet.sheetType === "dashboard") {
          if (filter.appliedValues === "ALL") {
            pageOperations.push(
              sheet.applyFilterAsync(
                filter.name,
                [],
                "all"
              )
            );
          } else if (
            Array.isArray(filter.appliedValues)
          ) {
            pageOperations.push(
              sheet.applyFilterAsync(
                filter.name,
                filter.appliedValues,
                "replace"
              )
            );
          }

          continue;
        }
        if (filter.appliedValues === "ALL") {
          pageOperations.push(
            sheet.clearFilterAsync(filter.name)
          );
        } else if (
          Array.isArray(filter.appliedValues)
        ) {
          pageOperations.push(
            sheet.applyFilterAsync(
              filter.name,
              filter.appliedValues,
              "replace"
            )
          );
        }
      }

      const categoricalResults =
        await Promise.allSettled(pageOperations);

      failedOperations.push(
        ...categoricalResults.filter(
          (result) => result.status === "rejected"
        )
      );

      if (!worksheetOnlyFilters.length) {
        continue;
      }

      if (sheet.sheetType === "worksheet") {
        const worksheetOperations = [];

        for (const filter of worksheetOnlyFilters) {
          if (filter.type === "range") {
            worksheetOperations.push(
              sheet.applyRangeFilterAsync(
                filter.name,
                {
                  min: filter.minValue?._value,
                  max: filter.maxValue?._value,
                }
              )
            );

            continue;
          }

          if (
            filter.type === "relativedate" &&
            typeof sheet
              .applyRelativeDateFilterAsync ===
              "function"
          ) {
            worksheetOperations.push(
              sheet.applyRelativeDateFilterAsync(
                filter.name,
                {
                  periodType: filter.periodType,
                  rangeN: filter.rangeN,
                }
              )
            );
          }
        }

        const worksheetResults =
          await Promise.allSettled(
            worksheetOperations
          );

        failedOperations.push(
          ...worksheetResults.filter(
            (result) =>
              result.status === "rejected"
          )
        );

        continue;
      }

      const relevantFilterNames = new Set(
        worksheetOnlyFilters.map(
          (filter) => filter.name
        )
      );

      const worksheetFilters = await Promise.all(
        sheet.worksheets.map(async (worksheet) => {
          try {
            const existingFilters =
              await worksheet.getFiltersAsync();

            return {
              worksheet,
              filterNames: new Set(
                existingFilters
                  .map((filter) => filter.fieldName)
                  .filter((name) =>
                    relevantFilterNames.has(name)
                  )
              ),
            };
          } catch (error) {
            failedOperations.push({
              status: "rejected",
              reason: error,
              operation: "getWorksheetFilters",
              sheet: sheetInfo.name,
              worksheet: worksheet.name,
            });

            return {
              worksheet,
              filterNames: new Set(),
            };
          }
        })
      );

      const worksheetOperations = [];

      for (const filter of worksheetOnlyFilters) {
        const targetWorksheets = worksheetFilters
          .filter(({ filterNames }) =>
            filterNames.has(filter.name)
          )
          .map(({ worksheet }) => worksheet);

        for (const worksheet of targetWorksheets) {
          if (filter.type === "range") {
            worksheetOperations.push(
              worksheet.applyRangeFilterAsync(
                filter.name,
                {
                  min: filter.minValue?._value,
                  max: filter.maxValue?._value,
                }
              )
            );

            continue;
          }

          if (
            filter.type === "relativedate" &&
            typeof worksheet
              .applyRelativeDateFilterAsync ===
              "function"
          ) {
            worksheetOperations.push(
              worksheet.applyRelativeDateFilterAsync(
                filter.name,
                {
                  periodType: filter.periodType,
                  rangeN: filter.rangeN,
                }
              )
            );
          }
        }
      }

      const worksheetResults =
        await Promise.allSettled(
          worksheetOperations
        );

      failedOperations.push(
        ...worksheetResults.filter(
          (result) => result.status === "rejected"
        )
      );
    }
  } finally {
    if (
      workbook.activeSheet.name !== initialSheetName
    ) {
      try {
        await workbook.activateSheetAsync(
          initialSheetName
        );
      } catch (error) {
        failedOperations.push({
          status: "rejected",
          reason: error,
          operation: "restoreInitialSheet",
          sheet: initialSheetName,
        });
      }
    }
  }

  if (failedOperations.length) {
    console.warn(
      `Some filter/parameter ops failed (${failedOperations.length}).`,
      failedOperations
    );
  }

  setLoadingContent?.(false);
};
